// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateNewCard_container__1uToZ","button":"CreateNewCard_button__3Jf2m","content":"CreateNewCard_content__21Rcw"};